<style scoped lang="less">
</style>

<template>
    <div class="yb-container">
        <div class="line-container">
            <el-button size="mini" type="success" v-if="isAdmin" @click.stop="addOrEdit(null)">新增</el-button>
            <el-button size="mini" type="primary" @click.stop="backup">备份数据库</el-button>
        </div>

        <paged-table ref="table" @fetch-data="fetchData" class="block-mini-top">
            <el-table slot :data="data" border size="mini" :cell-style="$parent.$parent.cellStyle">
                <el-table-column type="index" align="center" width="45">
                </el-table-column>
                <el-table-column label="账号描述" align="center" prop="description" width="100"></el-table-column>
                <el-table-column label="用户名" align="center" width="100">
                    <template slot-scope="scope">
                        {{scope.row.username}}
                    </template>
                </el-table-column>
                <el-table-column label="密码" align="center" width="100">
                    <template slot-scope="scope">
                        {{scope.row.password}}
                    </template>
                </el-table-column>
                <el-table-column label="权限" width="300">
                    <template slot-scope="scope">
                        <div v-if="scope.row.masterAdmin">true</div>
                        <div v-else v-for="item in calcMenus(scope.row)">
                            {{item}}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column label="门店" align="center" width="100">
                    <template slot-scope="scope" v-if="scope.row.store">
                        {{scope.row.store.name}}
                    </template>
                </el-table-column>

                <el-table-column label="操作" v-if="isAdmin">
                    <template slot-scope="scope">
                        <el-button class="super-mini-button" type="primary" size="mini"
                            @click.stop="addOrEdit(scope.row)">编辑</el-button>
                        <el-button v-if="!scope.row.masterAdmin" class="super-mini-button" type="danger" size="mini"
                            @click.stop="removeModel(scope.row)">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </paged-table>

        <dialog-edit-admin ref="edit" @fetch-data="fetchData"></dialog-edit-admin>
    </div>
</template>

<script>
import PagedTable from "../components/PagedTable";
import { HttpClient } from "../util/http";

import DialogEditAdmin from "../components/dialog/dialogEditAdmin";
import { removeModel } from "../util/restful";
import { actionConfirm, msgSuccess } from "../util/toast";
import { loginState } from "../util/login.js";
import * as xlsx from "xlsx";
import { exportExcel } from "../util/exportExcel";

export default {
    components: {
        DialogEditAdmin,
        PagedTable,
    },
    mixins: [],
    data() {
        return {
            data: [],
        };
    },
    created() {},
    computed: {
        table() {
            return this.$refs.table;
        },
        edit() {
            return this.$refs.edit;
        },
        isAdmin() {
            if (loginState && loginState.admin) {
                if (loginState.admin.username == "qianyou") {
                    return true;
                }
                return loginState.admin.masterAdmin;
            } else {
                return false;
            }
        },
    },
    mounted() {},
    methods: {
        async backup() {
            await actionConfirm();
            await HttpClient.post("/admin/backup");
            msgSuccess();
        },
        calcMenus(item) {
            let menus = [];
            menus = item.menus.map((it) => {
                return (
                    it.text +
                    " -> " +
                    it.submenus.map((it2) => it2.text).join(", ")
                );
            });
            return menus;
        },
        refetchData() {
            this.table.refetchData();
        },
        async fetchData() {
            let cond = {};
            let res = await HttpClient.post("/restful", {
                model: "Admin",
                cond,
                sort: {
                    _id: -1,
                },
                populate: "store",
                pageSize: this.table.pageSize,
                pageNum: this.table.pageNum,
                withCount: true,
            });

            res = res.result;

            let result = [];
            for (let i = 0; i < res.length; i++) {
                const admin = res[i];
                let menus = loginState.userToMenus(admin);
                let item = {
                    ...admin,
                    menus,
                };
                result.push(item);
            }
            this.data = result;
        },
        addOrEdit(item) {
            this.edit.addOrEdit(item);
        },
        async removeModel(item) {
            await actionConfirm();
            await removeModel("Admin", item._id);
            msgSuccess();
            this.refetchData();
        },
    },
};
</script>
